import { AuthRoutes } from 'src/features/auth/routes';

export const publicRoutes = [
    {
        path: '/*',
        element: <AuthRoutes />,
    },
];
